import { DateTime } from '@ksyos/date-time';
import type { OsasFollowUpConsultCustomControlData } from '@common/validation/customControls/osas/osasFollowUpConsultSchema';
import {
    osasConsultExaminationInitialData,
    osasYesChosenTreatmentInitialData,
    therapielandProgramSelectionInitialData,
    watchPatSleepStudyPdfInitialData,
} from '../osasConsult/osasConsultData';
import { initialTreatmentChoiceData } from '../osasEvaluation/osasEvaluationData';

export const initialData: OsasFollowUpConsultCustomControlData = {
    ...osasConsultExaminationInitialData,
    ...watchPatSleepStudyPdfInitialData,
    ...osasYesChosenTreatmentInitialData,
    ...therapielandProgramSelectionInitialData,
    anamnesis: null,
    assets: [],
    conclusie: null,
    consultDate: DateTime.now().format('YYYY-MM-DD'),
    hasTreatment: false,
    isTreatmentStarted: null,
    notes: null,
    taskForPoliclinic: null,
    treatmentChoice: initialTreatmentChoiceData,
    trialPeriod: null,
};
